import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export async function getAllCategories(callback) {
	firebaseRef
		.ref('/kavtek_report_categories/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			var categories = snapshot.val();

			var categegoryKeys = Object.keys(categories);
			var categoryArr = [];

			categegoryKeys.forEach((key) => {
				var categegory = categories[key];

				var categoryObj = {
					id: categegory.id,
					name: categegory.name,
				};

				categoryArr.push(categoryObj);
			});

			callback(categoryArr);
		});
}
